import React from 'react'
import { Outlet } from 'react-router-dom'
import {
  PageHome,
  PageError404,
  PageAbout,
  PageContact,
  PageTermsAndConditions,
  PagePrivacyPolicy,
  PageDlgDisclosure,
  PageRefundAndCancellationPolicy,
  PageGrievanceRedressalAndDisclosures,
} from 'screens/index'
import { Header, Footer } from 'organisms'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ScrollToHash from './scrollToHash'

function ViewWithHeaderAndFooter() {
  return (
    <>
      <ScrollToHash />
      <ToastContainer />
      <Header />
      <div className="flex min-h-screen flex-col">
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  )
}

export default function routes() {
  return [
    {
      path: '/',
      element: <ViewWithHeaderAndFooter />,
      children: [
        {
          path: '/',
          element: <PageHome />,
        },

        {
          path: '/terms-and-conditions',
          element: <PageTermsAndConditions />,
        },
        {
          path: '/privacy-policy',
          element: <PagePrivacyPolicy />,
        },
        {
          path: '/dlg-disclosure',
          element: <PageDlgDisclosure />,
        },
        {
          path: '/refund-and-cancellation-policy',
          element: <PageRefundAndCancellationPolicy />,
        },
        {
          path: '/grievance-redressal-and-disclosures',
          element: <PageGrievanceRedressalAndDisclosures />,
        },
        {
          path: '*',
          element: <PageError404 />,
        },
      ],
    },
  ]
}
